import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class FilenameService {
  constructor(private readonly translateService: TranslateService) {}

  getFilename(key: string): string {
    const timespan = this.getTimeSpan();
    return this.translateService.instant(key, {timespan});
  }

  private getTimeSpan() {
    const dt = new Date();
    const month = (dt.getMonth() + 1).toString().padStart(2, '0');
    const day = dt.getDate().toString().padStart(2, '0');
    const hours = dt.getHours().toString().padStart(2, '0');
    const minutes = dt.getMinutes().toString().padStart(2, '0');
    return `${dt.getFullYear()}${month}${day}_${hours}${minutes}`;
  }
}
